import firebase from "firebase/compat/app";
import "firebase/compat/auth";

/**
 * check if user has email provider data
 * @param user
 */
export const hasEmailProviderData = (user: firebase.User): boolean => {
  const havingProviderIdList = user.providerData.map(
    // @ts-expect-error TS18047
    (provider) => provider.providerId
  );
  return havingProviderIdList.includes(
    firebase.auth.EmailAuthProvider.PROVIDER_ID
  );
};

/**
 * check if user need reauth
 * @param user
 */
export const isReAuthRequiredToEditAddress = (
  user: firebase.User,
  isWhenPageEnter = false
): boolean => {
  // @ts-expect-error TS2769
  const lastSignInTime = new Date(user.metadata.lastSignInTime);
  const now = new Date();
  // 登録APIの再認証要求までの時間は30分だが、
  // 再認証後に登録処理を行ってもらうようにするためフロントは短めにする。
  // isWhenPageEnter 判定はなるべくページに入ったら再認証をしてもらうようにするため
  // 時間を延ばした経緯: https://github.com/balus-co-ltd/spwn-web/issues/274
  const reauthRequirationSeconds = isWhenPageEnter ? 900 : 1500;
  return (
    lastSignInTime.getTime() + reauthRequirationSeconds * 1000 < now.getTime()
  );
};
